/**
 * Role identifiers exactly as they are stored in the database.
 *
 * The numbers carry no ranking. ADMIN (99) is the highest, but DATA_MANAGER (1)
 * is more privileged than USER (3). Never compare a role with `<` or `>`, and
 * never test a bare number in a component — ask RoleUtils instead, where every
 * check is a membership test against an explicit list.
 */
export const ROLES = {
  PENDING: 0,
  DATA_MANAGER: 1,
  RESEARCHER: 2,
  USER: 3,
  ADMIN: 99,
};

/** Human readable name for every role, used wherever a role is displayed. */
export const ROLE_LABELS = {
  [ROLES.PENDING]: 'Pending',
  [ROLES.DATA_MANAGER]: 'Data Manager',
  [ROLES.RESEARCHER]: 'Researcher',
  [ROLES.USER]: 'User',
  [ROLES.ADMIN]: 'Admin',
};

/**
 * Options offered by the role dropdown when creating or editing a user.
 * PENDING is deliberately absent: it is the state a self-registered account
 * starts in, not something an administrator assigns.
 */
export const ROLE_OPTIONS = [
  { value: ROLES.ADMIN, label: ROLE_LABELS[ROLES.ADMIN] },
  { value: ROLES.DATA_MANAGER, label: ROLE_LABELS[ROLES.DATA_MANAGER] },
  { value: ROLES.RESEARCHER, label: ROLE_LABELS[ROLES.RESEARCHER] },
  { value: ROLES.USER, label: ROLE_LABELS[ROLES.USER] },
];
